import { render, staticRenderFns } from "./GameEngine.vue?vue&type=template&id=2dc058a4&scoped=true"
import script from "./GameEngine.vue?vue&type=script&lang=js"
export * from "./GameEngine.vue?vue&type=script&lang=js"
import style0 from "./GameEngine.vue?vue&type=style&index=0&id=2dc058a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc058a4",
  null
  
)

export default component.exports